export default __webpack_public_path__ + "static/media/logo2.66773f90.png";